import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox";
import * as types from "../../constants/actionTypes";
import { setLoader } from "./actions";
import moment from "moment";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST, PUT } from "../../service/api";
import { Header } from "../../constants/headers";

const getStateModule = (state) => state.ModuleKasir;

export function* getListRekamMedis() {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _id_dokter = JSON.parse(localStorage.getItem("UserData")).f_id_dokter;
    const _body = {
      id: _id,
      id_dokter: _id_dokter,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_REKAMMEDIS_LIST_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_REKAMMEDIS_LISTDATA_REKAMMEDIS_GET_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getDetailRekamMedis(params) {
  try {
    yield put(setLoader(true));
    const _body = {
      detail: params.value,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_REKAMMEDIS_LIST_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_REKAMMEDIS_DETAIL_REKAMMEDIS_GET_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(types.MODULE_REKAMMEDIS_LISTDATA_REKAMMEDIS_GET, getListRekamMedis), takeLatest(types.MODULE_REKAMMEDIS_DETAIL_REKAMMEDIS_GET, getDetailRekamMedis)]);
}
